import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";

const LISTADO_MATERIAL = 'LISTADO_MATERIAL';
const GUARDAR_MATERIAL = 'GUARDAR_MATERIAL';
const LOADER = 'LOADER';
const MODULO = 'MODULO';

const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    //const params = { page, id };
    const params = { id };
    dispatch(setLoader(true));
    api.get('/material', params).then((response)=>{
        dispatch({ type: LISTADO_MATERIAL, data: response });
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al listar materiales',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const registroMaterial = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormMaterial.values;
    const formData = {
        descripcion: data.descripcion,
        empresa: id_emp[5]
    }
    dispatch(setLoader(true));
    api.post('/material/', formData).then((response) => {
        NotificationManager.success(
        'Material creado',
        'Exito',
        3000
    );
    let ruta = `/inmobiliaria/${id_emp[5]}/materiales`
    dispatch(push(ruta));
    }).catch((error) => {
    NotificationManager.error(
        error.msj,
        'Error',
        2000
    );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const modificarMaterial = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const datos = getStore().form.FormMaterial.values;
    const id = datos.id;
    const formData = {
        id: id,
        descripcion: datos.descripcion
    }
    dispatch(setLoader(true));
    api.put(`/material/${id}/`, formData).then(() => {
        NotificationManager.success(
            'Material modificado correctamente',
            'Exito',
            3000
        );
        let ruta = `/inmobiliaria/${id_emp[5]}/materiales`
        dispatch(push(ruta));
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al modificar el material',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/material/${id}`).then((response) => {
        dispatch({type: GUARDAR_MATERIAL, lectura: response });
        dispatch(initializeForm('FormMaterial', response ));
    }).catch((error)=>{
        console.log("error: ", error)
        NotificationManager.error(
            'Ocurrió un error al consultar material',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en buscar modulo',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const actions = {
    listar,
    registroMaterial,
    modificarMaterial,
    leer,
    getModulo
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LISTADO_MATERIAL]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [GUARDAR_MATERIAL]: (state, { lectura }) => {
        return {
            ...state,
            lectura,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
};

export const initialState = {
    loader: false,
    lectura: [],
    modulo: [],
    data: [],
    page: 1,
};

export default handleActions(reducers, initialState)
 